import compose from 'ramda/src/compose';
import flatten from 'ramda/src/flatten';
import partition from 'ramda/src/partition';
import pathOr from 'ramda/src/pathOr';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeTypeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { createSelector } from 'reselect';
import { parseAdditionalProperties } from '../helpers/payment.instrument.additional.property.parser';
import { AutopayConfigurationAdditionalProperties, autopayConfigurationAdditionalPropertyDescriptors } from '../helpers/autopay.configuration.additional.property.parser';
export var AutopayConfigurationAdditionalPropertiesSelector = createSelector([MetadataCodeTypeSelector(CODES.AutopayConfig)], function (autopayConfiguration) {
  return (autopayConfiguration || []).reduce(function (lookup, paymentType) {
    var model = new AutopayConfigurationAdditionalProperties();
    return parseAdditionalProperties(model, paymentType.AdditionalProperties, autopayConfigurationAdditionalPropertyDescriptors);
  }, {});
});
export var IsAutoPayEnabledSelector = createImmutableSelector([MetadataCodeTypeSelector(CODES.SubscriberSearchConfig)], function (codes) {
  if (codes.length) {
    var codesSortedByGlobalFirst = compose(flatten, partition(function (code) {
      return code.Global;
    }))(codes);
    var lastEnableAutopayAdditionalProperty = codesSortedByGlobalFirst[codesSortedByGlobalFirst.length - 1].AdditionalProperties.find(function (additionalProperty) {
      return additionalProperty.Key === 'enable_autopay';
    });
    return pathOr('', ['Value'], lastEnableAutopayAdditionalProperty).toLowerCase() === 'true';
  }
});